import { Familia } from './Familia';
import { SubFamiliaId } from './SubFamiliaId';

export class SubFamilia {
    id: SubFamiliaId;
    familia: Familia;
    nombre: string;
    descripcion: string;
}